import React from 'react';
import { Outlet } from 'react-router-dom';
import { list, get } from '../../../features/applications/actions';

const index = () => {
  const page = 'Applications';
  return (
    <div style={{ height: '100%', paddingTop: '4rem' }}>
      <Outlet context={[{ page, list, get }]} />
    </div>
  );
};

export default index;
